import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paginate from '../components/Paginate';
import { Table, Button,Row,Col } from 'react-bootstrap';
import{PRODUCT_CREATE_RESET} from '../constants/productConst'
import{REGISTER_EVENT_LIST_SUCCESS} from '../constants/resgistertEventConst'
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { Pagination } from 'react-bootstrap';
// import User from '../../../backend/models/userModel';
import { listregisterevents,deleteregisterevent,createregisterevent } from '../actions/registereventActions';
import copy from 'copy-to-clipboard';

const RegistereventListScreen = ({isAdmin=false,keyword=''}) => {
  // const pageSize=8
  // const page=Number(query.pageNumber) || 1
  // const pageNumber=match.params.pageNumber || 1
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const [products, setProducts] = useState([]);
  const [storeDetails, setStoreDetails] = useState([]);
  const dispatch = useDispatch();
  const createdDate = new Date().toISOString();  
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
 
  console.log("1111111111111111111111111111");
  console.log(window.Shopline.handle);
  //console.log(storeDetails);
  console.log("222222222222222222222222222222");
  // const { pages,page } = res.data;
  useEffect(() => {

    if (window.Shopline.customer !== undefined) {
        axios.get(`https://wiser-ai.expertvillagemedia.com/api/getregistry/${window.Shopline.handle}/${window.Shopline.customer.id}`)
        .then((res) => {
          console.log("3333333333333333333333333");
          console.log(res);
          console.log("444444444444444444444444");
          setProducts(res.data.data);
          console.log(res.data);
          const createdDate = new Date().toISOString();
          console.log("55555555555555555555555555");
          console.log(createdDate);
        });
        fetchProducts(page);    
        //console.log('Log this'+products+"+++");
    }
  }, [page]);

  const fetchProducts = async (pageNumber) => {
    try {      
      //const response = await axios.get(`https://wiser-ai.expertvillagemedia.com/api/getregistry/${window.Shopline.handle}`);
      axios.get(`https://wiser-ai.expertvillagemedia.com/api/getregistry/${window.Shopline.handle}/${window.Shopline.customer.id}`)
      .then((res) => {
        setProducts(res.data.data);
        const createdDate = new Date().toISOString();
      });
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const handleTabClick = () => {
    
  }

  const handlePageChange = (pageNumber) => {
    //setPage(pageNumber);
  };

  const config = {
    headers: {
      //Authorization:`Bearer ${userInfo.token}`
    },  
  }
      
  /** DELETE CUSTOMER HANDLE */
  const deleteHandler = async (id) => {
    if (window.confirm('Are you sure?')) {
      const AppEndPointURL = `https://wiser-ai.expertvillagemedia.com/api/deleteregistry/${id}`;
      try {
          // Delete the product using axios
          await axios.get(AppEndPointURL, config);  
          // Fetch updated products after successful deletion
          /*const response = await axios.get(`/api/registarevent/?pageNumber=${page}&limit=5`);
          const { registerevents, pages } = response.data;
          setProducts(registerevents);
          setPages(pages);
          */
          axios.get(`https://wiser-ai.expertvillagemedia.com/api/getregistry/${window.Shopline.handle}/${window.Shopline.customer.id}`)
          .then((res) => {
            setProducts(res.data.data);
            const createdDate = new Date().toISOString();
          });
          alert('Registry successfully deleted');          
      } catch (error) {
          console.error('Error deleting product:', error);
      }
    }    
  };

  const addProGiftRegistry = async (id) => {
    localStorage.setItem('gift_registry_id', id);
    window.Location.href=`/collection/${id}`;    
  };
  

  const shareProduct = (productId) => {
    // Generate the shareable link based on your app's URL structure
    const shareableLink = `https://${window.Shopline.handle}.myshopline.com/user-event/${productId}`;    
    // Copy the link to the clipboard
    copy(shareableLink);    
    // You can also provide feedback to the user that the link has been copied
    alert('Product link copied to clipboard!');
  };

  return (
    <div> 
      {window.Shopline.customer === undefined  &&
        <div className='create-registry-wr'>
          <h1>Please login before to access gift registry</h1>
          <a href="/user/signIn" > Sign In </a>
        </div>
      }
      {window.Shopline.customer !== '' && window.Shopline.customer !== undefined  &&      
        <table className="table table-bordered searchlist_responsive table_custom">
            <thead className="sm_d_none">
              <tr>
                <th style={{ width: 'auto' }} className=''>S.No.</th>
                <th style={{ width: 'auto' }}>Event Id</th>
                <th style={{ width: 'auto' }}>Event Name</th>
                <th style={{ width: '15%' }} className="">
                  Event Date
                </th>
                <th style={{ width: '15%' }} className="">
                  Create Date
                </th>
                <th style={{ width: '15%' }} className="">
                  Owner
                </th>
                <th style={{ width: '15%' }} className="">
                  Share
                </th>
                <th style={{ width: 'auto' }} className="ifcustomer">
                  View
                </th>
                <th style={{ width: 'auto' }} className="ifcustomer">
                  Edit
                </th>
                <th style={{ width: 'auto' }} className="ifcustomer">
                  Delete
                </th>
                <th style={{ width: 'auto' }} className="ifcustomer">
                  Add Products In Gift Registry
                </th>             
              </tr>
            </thead>
            <tbody>
            {products.length === 0 ? (
              <tr>
                <td colSpan="8">
                  <p>No registries found.</p>
                  <Link to="/create-registry" onClick={() => handleTabClick(1)}>Create a new registry</Link>
                </td>
              </tr>
            ) : (           

              products.map((product, index) => (
                <tr key={index}>
                  {/* Populate the table cells with the registry data */}
                  {/* Populate the table cells with the registry data */}
                  <td>{index + 1}</td>
                  <td>{product.id}</td>
                  <td>{product.regtype}</td>
                  <td>{product.regdate}</td>
                  <td>{createdDate}</td>
                  {/* <td>{new Date(product.createDate).toLocaleDateString()}</td> Display the formatted creation date */}
                  <td>{product.r_fname}</td>
                  <td><Button variant='primary' className='btn-sm'
                        onClick={() => shareProduct(product._id)}
                      >Share</Button>
                  </td>
                  <td><Link to={`/user-event/${product.id}`}>View</Link></td>
                  <td><Link to={`/admin/editRegistry/${product.id}`}>Edit</Link></td>                  
                  <td><Button variant='danger' className='btn-sm' onClick={()=>deleteHandler(product.id)}>
                    Delete
                  </Button></td>
                  <td>
                    <Button variant='add' className='btn-sm' onClick={()=>addProGiftRegistry(product.id)}>
                      Add Products
                    </Button>
                  </td>
                </tr>
              ))
            )}
            </tbody>
        </table>
      }
    </div>
  );
}

export default RegistereventListScreen;

